/**
 * @generated SignedSource<<56a6b67b9894e4d65149341a94c67e70>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
export type BuildState = "deleted" | "finished" | "queued" | "running" | "unknown";
import { FragmentRefs } from "relay-runtime";
export type BuildsTimelineFragment$data = {
  readonly build: ReadonlyArray<{
    readonly finishDate: string | null | undefined;
    readonly queuedDate: string | null | undefined;
    readonly rawId: number | null | undefined;
    readonly runningInfo: {
      readonly elapsedSeconds: number | null | undefined;
    } | null | undefined;
    readonly startDate: string | null | undefined;
    readonly state: BuildState | null | undefined;
    readonly " $fragmentSpreads": FragmentRefs<"BuildStatsBarFragment">;
  }> | null | undefined;
  readonly " $fragmentType": "BuildsTimelineFragment";
};
export type BuildsTimelineFragment$key = {
  readonly " $data"?: BuildsTimelineFragment$data;
  readonly " $fragmentSpreads": FragmentRefs<"BuildsTimelineFragment">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "BuildsTimelineFragment",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "Build",
      "kind": "LinkedField",
      "name": "build",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "rawId",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "state",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "startDate",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "queuedDate",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "finishDate",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "ProgressInfo",
          "kind": "LinkedField",
          "name": "runningInfo",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "elapsedSeconds",
              "storageKey": null
            }
          ],
          "storageKey": null
        },
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "BuildStatsBarFragment"
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Builds",
  "abstractKey": null
};

(node as any).hash = "90bef096a4ae04d5cdbf0183d017d8f7";

export default node;
